<div id="wrapper">
    <app-loading-screen [status]=true></app-loading-screen>
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav 
        (updateType)="this.type=$event" 
        (updatePostpaid)="this.postpago=$event" 
        (updatePrepaid)="this.prepago=$event" 
        (updateFixed)="this.telefoniaFijo=$event" 
        (updateTotalAccountList)="this.totalAccountList=$event" 
        (updateCurrentList)="this.currentList=$event"
        (updateSelectBan)="this.selectBan=$event" 
        (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
    <div class="allcont logsize m-top-i" *ngIf="this.totalAccountList > 0">
        <app-payment-component [dataPay]="this.paymentData" *ngIf="this.screenview==1"
            (updatescreenview)="this.screenview=$event"></app-payment-component>
        <div class="basicrow" *ngIf="this.screenview!=1">
            <div class="container">
                <div class="basicr-line-i">
                    <div class="fulltitle  f-btitle autodef">
                        <span class="icon-dash-08"></span> Paquetes Adicionales de Datos
                    </div>
                    <div class="pull-right">
                        <label class="label-r sidenmbr vcenter w-auto">
                            <span class="tabcell">
                                N&uacute;mero de Cuenta
                            </span>
                        </label>
                        <div class="autorow subsc  mob-wid pull-right">
                            <div>
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(../../assets/images/selectabarrw.png)">
                                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                        {{list.account}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow mbott m-top-i" id="last-div" *ngIf="this.screenview!=1">
            <div class="container">
                <div class="basicrow mbott bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify">
                    Selecciona el <span class="roboto-b">n&uacute;mero de cuenta y n&uacute;mero de suscriptor</span> a la que deseas que se le aplique la compra.
                </div>
                <div *ngIf="this.type=='fixed' && this.screenview!=1" class="basicrow mbott bg-gray allpads bg-gray-u f-reg roboto-r f-black text-justify">
                    Para las cuentas fijas no aplica la compra de paquete por favor selecione una cuenta movil.
                </div>
                <div class="autowcont notopbrd">
                    <div ng-if="subscriber.productTypeField==this.typeSesion">
                        <div *ngFor="let inf of this.subscribers; let i = index" class="basicrow m">
                            <div *ngIf="inf.productTypeField=='G'">
                                <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i"
                                    class="digs-box-f vcenter mob-txt nolatbrd" (click)="updateExpand(i)"
                                    [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                                    <span class="roboto-l">M&Oacute;VIL </span>
                                    <span class="roboto-l">{{this.mask(inf.subscriberNumberField)}}</span>
                                    <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                                    <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                                </div>
                                <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                                    <div class="basicrow allpads  text-justify mob-txt-a">
                                        <app-current-plan [index]="i"></app-current-plan>
                                    </div>
                                    <app-carousel-datapurchase 
                                        [subscriber]="inf"
                                        [index]="i"
                                        [offers]="this.offers"
                                        (updatepayment)="this.paymentData=$event"
                                        (updateInitializeData)="this.initializeData()"
                                        (updatescreenview)="this.screenview=$event">
                                    </app-carousel-datapurchase>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aceptarTerminos">
                    <div (click)="this.displayTerms()" class="linkdefs">Acepto los T&eacute;rminos y Condiciones&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>